<template>
  <div class="user-info-content">
    <div class="form-header">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
        <circle cx="12" cy="7" r="4"></circle>
      </svg>
      <h2>פרטים אישיים</h2>
    </div>

    <form @submit.prevent="handleSubmit" class="signup-form">
      <div class="form-scroll">
        <div class="form-row">
          <div class="input-group">
            <label for="fname">שם פרטי</label>
            <div class="input-wrapper" :class="{ error: fnameError }">
              <input
                id="fname"
                ref="fnameField"
                type="text"
                placeholder="שם פרטי"
                v-model="fname"
                autofocus
              />
            </div>
          </div>

          <div class="input-group">
            <label for="lname">שם משפחה</label>
            <div class="input-wrapper" :class="{ error: lnameError }">
              <input
                id="lname"
                type="text"
                placeholder="שם משפחה"
                v-model="lname"
              />
            </div>
          </div>
        </div>

        <div class="input-group">
          <label for="email">אימייל</label>
          <div class="input-wrapper" :class="{ error: emailError }">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
              <polyline points="22,6 12,13 2,6"></polyline>
            </svg>
            <input
              id="email"
              type="email"
              placeholder="example@email.com"
              v-model="email"
              :disabled="!!states.authEmail"
            />
          </div>
        </div>

        <div class="input-group">
          <label for="phone">מספר טלפון</label>
          <div class="input-wrapper" :class="{ error: phoneError }">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
            </svg>
            <input
              id="phone"
              type="tel"
              placeholder="05X-XXXXXXX"
              v-model="phone"
              dir="ltr"
              class="phone-input"
              :disabled="!!states.authPhoneNumber"
            />
          </div>
          <span class="field-note">הטלפון יהיה זמין עבור מנהלי האפליקציה בלבד</span>
        </div>

        <div class="form-row">
          <div class="input-group">
            <label for="pwd">סיסמה</label>
            <div class="input-wrapper" :class="{ error: pwdError }">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
              <input
                id="pwd"
                :type="showPwd ? 'text' : 'password'"
                placeholder="סיסמה"
                v-model="pwd"
              />
              <button type="button" class="toggle-pwd" @click="showPwd = !showPwd">
                <svg v-if="!showPwd" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                  <line x1="1" y1="1" x2="23" y2="23"></line>
                </svg>
              </button>
            </div>
          </div>

          <div class="input-group">
            <label for="pwdVer">אישור סיסמה</label>
            <div class="input-wrapper" :class="{ error: pwdError }">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
              <input
                id="pwdVer"
                :type="showPwdVer ? 'text' : 'password'"
                placeholder="אישור סיסמה"
                v-model="pwdVer"
              />
              <button type="button" class="toggle-pwd" @click="showPwdVer = !showPwdVer">
                <svg v-if="!showPwdVer" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                  <line x1="1" y1="1" x2="23" y2="23"></line>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="input-group">
            <label for="gender">מגדר</label>
            <div class="input-wrapper select-wrapper" :class="{ error: genderError }">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="8" r="5"></circle>
                <path d="M20 21a8 8 0 1 0-16 0"></path>
              </svg>
              <select id="gender" v-model="gender">
                <option disabled value="">בחר מגדר</option>
                <option>זכר</option>
                <option>נקבה</option>
              </select>
            </div>
          </div>

          <div class="input-group">
            <label for="dob">תאריך לידה</label>
            <div class="input-wrapper" :class="{ error: dobError }">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
              <input
                id="dob"
                type="date"
                v-model="dob"
              />
            </div>
          </div>
        </div>
      </div>

      <div v-if="errorMessage" class="error-message">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
        {{ errorMessage }}
      </div>

      <div class="button-group">
        <button type="submit" class="submit-btn" :disabled="isPending">
          <span v-if="!isPending">שמור והמשך</span>
          <span v-else class="loading">
            <svg class="spinner" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" fill="none" stroke-linecap="round" stroke-dasharray="31.4 31.4" />
            </svg>
            שומר...
          </span>
        </button>
        <button type="button" class="cancel-btn" @click="cancel">ביטול</button>
      </div>
    </form>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { uploadUserImage } from '@/composables/useStorage.js'
import { projectAuth } from '@/firebase/config'
import { states } from '@/main_store'
import { isValidEmail, isValidIsraeliPhoneNumber } from '@/scripts/utils'
import { useRouter } from "vue-router"

const router = useRouter()

const fname = ref('')
const fnameError = ref(false)
const lname = ref('')
const lnameError = ref(false)
const phone = ref(states.value.authPhoneNumber ? states.value.authPhoneNumber.replace('+972', '0') : '')
const phoneError = ref(false)
const email = ref(states.value.authEmail ? states.value.authEmail : '')
const emailError = ref(false)
const pwd = ref('')
const pwdVer = ref('')
const pwdError = ref(false)
const gender = ref('')
const genderError = ref(false)
const dob = ref('')
const dobError = ref(false)
const fnameField = ref("fnameField")
const isPending = ref(false)
const files = ref()
const fileInput = ref(null)
const emit = defineEmits();
const errorMessage = ref('')

const showPwd = ref(false)
const showPwdVer = ref(false)

const handleFileChange = async () => {
  files.value = fileInput.value?.files
}

const handleSubmit = async () => {
  errorMessage.value = ''
  const file = files.value ? files.value[0] : null
  const imageUrl = file ? await uploadUserImage(file, projectAuth.currentUser.uid) : null

  fnameError.value = fname.value === ''
  lnameError.value = lname.value === ''
  emailError.value = email.value === ''
  phoneError.value = phone.value === ''
  genderError.value = gender.value === ''
  dobError.value = dob.value === ''
  pwdError.value = pwd.value === ''

  if (fnameError.value || lnameError.value || emailError.value || phoneError.value || genderError.value || dobError.value || pwdError.value) {
    errorMessage.value = 'אנא מלא את כל השדות המסומנים באדום.'
    return
  }

  if (pwd.value !== pwdVer.value) {
    pwdError.value = true
    errorMessage.value = 'אישור הסיסמה אינו תואם לסיסמה המקורית.'
    return
  }

  if (!isValidIsraeliPhoneNumber(phone.value)) {
    phoneError.value = true
    errorMessage.value = 'יש להזין מספר טלפון תקין.'
    return
  }

  if (!isValidEmail(email.value.trim())) {
    emailError.value = true
    errorMessage.value = 'יש להזין אימייל תקין.'
    return
  }

  const today = new Date()
  const birthDate = new Date(dob.value)
  let age = today.getFullYear() - birthDate.getFullYear()
  const monthDiff = today.getMonth() - birthDate.getMonth()
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--
  }
  if (age < 18) {
    dobError.value = true
    errorMessage.value = 'ההרשמה מיועדת לגילאי 18 ומעלה בלבד.'
    return
  }

  isPending.value = true

  const personalDetails = {
    fname: fname.value,
    lname: lname.value,
    phone: phone.value,
    gender: gender.value,
    email: email.value,
    dob: dob.value,
    pwd: pwd.value,
    profileImage: imageUrl,
    pic_auth: 'pending',
    pic_up_date: new Date(),
    status: "unblocked"
  };

  emit('personal-details-submitted', personalDetails);
  isPending.value = false
}

const cancel = () => {
  router.push({ name: "Login" });
}

onMounted(() => {
  if (fnameField.value) {
    fnameField.value.focus();
  }
})
</script>

<style scoped>
/* PC Mode - Better visibility */
.user-info-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.form-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #667eea;
}

.form-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
}

.signup-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 100% !important;
  box-shadow: none !important;
  padding: 0 !important;
  margin: 0 !important;
}

.form-scroll {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.input-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.input-group label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
}

.input-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 12px;
  height: 44px;
  background: #f9fafb;
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  transition: all 0.2s ease;
}

.input-wrapper:focus-within {
  border-color: #667eea;
  background: white;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.input-wrapper.error {
  border-color: #ef4444;
  background: #fef2f2;
}

.input-wrapper svg {
  color: #9ca3af;
  flex-shrink: 0;
}

.input-wrapper:focus-within svg {
  color: #667eea;
}

.input-wrapper input,
.input-wrapper select {
  flex: 1;
  border: none;
  background: transparent;
  font-size: 15px;
  color: #1f2937;
  outline: none;
  width: 100%;
}

.input-wrapper input::placeholder {
  color: #9ca3af;
}

.input-wrapper input:disabled {
  color: #6b7280;
  cursor: not-allowed;
}

.phone-input {
  text-align: left;
}

.select-wrapper select {
  cursor: pointer;
  appearance: none;
}

.toggle-pwd {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #9ca3af;
  display: flex;
  transition: color 0.2s;
}

.toggle-pwd:hover {
  color: #667eea;
}

.field-note {
  font-size: 11px;
  color: #9ca3af;
}

.error-message {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  color: #dc2626;
  font-size: 13px;
}

.button-group {
  display: flex;
  gap: 10px;
  margin-top: 4px;
}

.submit-btn {
  flex: 1;
  height: 44px;
  padding: 0 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 10px;
  color: white;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.35);
}

.submit-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.45);
}

.submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.cancel-btn {
  height: 44px;
  padding: 0 20px;
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  color: #6b7280;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.cancel-btn:hover {
  border-color: #ef4444;
  color: #ef4444;
  background: #fef2f2;
}

.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.spinner {
  width: 18px;
  height: 18px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Mobile Mode - Full width form, scrollable with sticky buttons */
@media (max-width: 480px) {
  .user-info-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: 8px;
    overflow: hidden;
    width: 100%;
  }

  .form-header {
    flex-shrink: 0;
  }

  .signup-form {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
    width: 100%;
    max-width: 100% !important;
    box-shadow: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  .form-scroll {
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding-bottom: 8px;
    width: 100%;
    -webkit-overflow-scrolling: touch;
    /* Hide scrollbar but keep scroll */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE/Edge */
  }

  .form-scroll::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }

  .form-row {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
  }

  .input-group {
    width: 100% !important;
    max-width: 100% !important;
  }

  .input-group label {
    font-size: 13px;
  }

  .input-wrapper {
    height: 46px;
    width: 100% !important;
    max-width: 100% !important;
    padding: 0 12px;
    box-sizing: border-box;
    box-shadow: none !important;
  }

  .input-wrapper:focus-within {
    box-shadow: none !important;
  }

  .input-wrapper input,
  .input-wrapper select {
    font-size: 16px;
    width: 100%;
  }

  .button-group {
    flex-shrink: 0;
    padding: 10px 0 0 0;
    margin-top: auto;
    border-top: 1px solid #e5e7eb;
    background: white;
    width: 100%;
  }

  .submit-btn,
  .cancel-btn {
    height: 46px;
    font-size: 15px;
    box-shadow: none !important;
  }
}

/* Low height phones - more compact */
@media (max-height: 700px) and (max-width: 480px) {
  .user-info-content {
    gap: 6px;
  }

  .form-header h2 {
    font-size: 16px;
  }

  .form-header svg {
    width: 20px;
    height: 20px;
  }

  .form-scroll {
    gap: 8px;
  }

  .input-group {
    gap: 2px;
  }

  .input-group label {
    font-size: 12px;
  }

  .input-wrapper {
    height: 42px;
  }

  .button-group {
    padding-top: 8px;
  }

  .submit-btn,
  .cancel-btn {
    height: 42px;
    font-size: 14px;
  }
}
</style>
